// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1Uyer","placeholdersHeader":"styles_placeholdersHeader__aZ2VK","editorStyle":"styles_editorStyle__MJSB_","placeholdersBox":"styles_placeholdersBox__1l6ql"};